import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersDurationDropdown
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from, to, and amount fields
 * filled out and showing the scheduled dropdown open.
 * This capture is used in the following capture groups:
 * "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersDurationDropdown(props) {
    // Initialize all the model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new BCMSStateManagerCRUD instance using the default page data
    // Then updating the from, to and amount properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .update([ "transfer", "duration" ], "No End Date")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(data.transfer, globalController))
    .update([ "duration", "isActive" ], true)
    .submit();

    // Return the TransfersPage passing the data and ui variables
    return <TransfersPage data={ data } ui={ ui } />
}